<template>
  <div class="">
    <button @click="$emit('onPress')" class=" h-[200px]">
      <div class="flex flex-col items-center">
        <div
          class="bg-[#FBE5D6] rounded-full w-[150px] h-[150px] flex flex-col  items-center justify-center"
        >
          <img :src="src" :class="size" />
        </div>
        <div class="">
          {{ label }}
        </div>
      </div>
    </button>
  </div>
</template>
<script>
export default {
  props: ["label", "src", "size"],
};
</script>
